

































































































import {Component, Vue} from "vue-property-decorator";
import {PaginatedOrders} from "@/api/Order";
import OrderService from "@/service/OrderService";
import RenderOrderStatus from "@/components/Shared/RenderOrderStatus.vue";
import RenderPrice from "@/components/Shared/RenderPrice.vue";
import Loading from "@/components/Shared/Loading.vue";
import RenderEmpty from "@/components/Shared/RenderEmpty.vue";

@Component({
  components: {RenderEmpty, Loading, RenderPrice, RenderOrderStatus}
})
export default class GeneralCustomerInfo extends Vue {
  private orders: PaginatedOrders | null = null;

  public async getOrders() {
    const pageNumber = 1;
    const filter = "";
    this.$store.dispatch('loading/showLoadingModal');
    this.orders = await OrderService.getPaginatedOrders(pageNumber, filter);
    this.$store.dispatch('loading/hideLoadingModal');
  }

  async mounted() {
    await this.getOrders()
  }
}
